export const translations = {
  es: {
    // Nav
    'nav.today': 'Hoy',
    'nav.company': 'Mi empresa',
    'nav.finance': 'Finanzas',
    'nav.profitability': 'Rentabilidad',
    'nav.cash': 'Tesorería',
    'nav.plan': 'Planificar',
    'nav.forecast': 'Previsión',
    'nav.alerts': 'Alertas',
    'nav.tasks': 'Pendientes',
    'nav.advisor': 'Advisor',
    'nav.documents': 'Documentos',
    'nav.calendar': 'Calendario',
    'nav.recommendations': 'Recomendaciones',
    'nav.team': 'Mi equipo asesor',
    'nav.notifications': 'Notificaciones',
    'nav.group.overview': 'Visión general',
    'nav.group.intelligence': 'Inteligencia',
    'nav.group.action': 'Acción',
    'nav.more': 'Más',

    // Common
    'common.viewAll': 'Ver todo',
    'common.viewDetail': 'Ver detalle',
    'common.vsPrev': 'vs periodo anterior',
    'common.vsTarget': 'vs objetivo',
    'common.noData': 'SIN DATOS',
    'common.noDataDesc': 'Aún no hay datos suficientes conectados para mostrar esta información.',
    'common.connect': 'Conectar datos',
    'common.search': 'Buscar...',
    'common.close': 'Cerrar',
    'common.send': 'Enviar',
    'common.logout': 'Cerrar sesión',
    'common.settings': 'Configuración',
    'common.of': 'de',
    'common.showMore': 'Mostrar más',
    'common.why': '¿Por qué?',
    'common.whatToDo': '¿Qué hago?',
    'common.status': 'Estado',
    'common.amount': 'Importe',
    'common.date': 'Fecha',
    'common.pending': 'Pendiente',
    'common.done': 'Completado',
    'common.accept': 'Aceptar',
    'common.dismiss': 'Descartar',
    'common.upload': 'Subir',

    // Login
    'login.tagline': 'El centro financiero inteligente de tu empresa',
    'login.subtitle': 'Entiende cómo está tu empresa y sabe qué deberías hacer.',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.signin': 'Entrar',
    'login.demo': 'Acceder con cuenta demo',
    'login.selectCompany': 'Selecciona tu empresa',
    'login.selectCompanyDesc': 'Tienes acceso a varias organizaciones. Elige una para continuar.',
    'login.enter': 'Entrar',
    'login.feature1': 'Visibilidad · ¿Qué ocurre?',
    'login.feature2': 'Análisis · ¿Por qué ocurre?',
    'login.feature3': 'Predicción · ¿Qué ocurrirá?',
    'login.feature4': 'Asesoramiento · ¿Qué hago?',

    // Today
    'today.greeting': 'Buenos días',
    'today.intro': 'Aquí tienes lo más importante de tu empresa.',
    'today.healthStatus': 'Estado general',
    'today.requiresAttention': 'Requiere atención',
    'today.requiresAttentionDesc': 'Lo que necesita tu decisión hoy',
    'today.aiInsight': 'Insight del Advisor',
    'today.pending': 'Tus pendientes',
    'today.upcoming': 'Próximos vencimientos',

    // Health
    'health.title': 'Salud de la empresa',
    'health.subtitle': 'Una visión global sin necesidad de interpretar estados financieros.',
    'health.score': 'Puntuación de salud',
    'health.liquidity': 'Liquidez',
    'health.profitability': 'Rentabilidad',
    'health.growth': 'Crecimiento',
    'health.debt': 'Endeudamiento',
    'health.stability': 'Estabilidad',
    'health.risk': 'Riesgo',
    'health.trend': 'Evolución de la salud',

    // Finance
    'finance.title': 'Visión financiera',
    'finance.subtitle': 'Cuánto entra, cuánto sale y qué queda.',
    'finance.revenue': 'Facturación',
    'finance.expenses': 'Gastos',
    'finance.profit': 'Beneficio',
    'finance.margin': 'Margen',
    'finance.evolution': 'Evolución ingresos vs gastos',
    'finance.breakdown': 'Desglose de gastos',

    // Profitability
    'prof.title': 'Rentabilidad',
    'prof.subtitle': '¿Qué partes de tu negocio realmente generan beneficio?',
    'prof.clients': 'Clientes',
    'prof.products': 'Productos',
    'prof.services': 'Servicios',
    'prof.projects': 'Proyectos',
    'prof.departments': 'Departamentos',
    'prof.name': 'Nombre',
    'prof.marginPct': 'Margen',
    'prof.contribution': 'Contribución',

    // Cash
    'cash.title': 'Tesorería',
    'cash.subtitle': '¿Cuánto dinero tienes disponible y qué ocurrirá próximamente?',
    'cash.available': 'Disponible hoy',
    'cash.inflows': 'Cobros previstos',
    'cash.outflows': 'Pagos previstos',
    'cash.projected': 'Saldo proyectado',
    'cash.timeline': 'Proyección de tesorería (90 días)',
    'cash.movements': 'Próximos movimientos',
    'cash.runway': 'Autonomía de caja',
    'cash.months': 'meses',

    // Scenario
    'scenario.title': 'Planificador de escenarios',
    'scenario.subtitle': 'Responde preguntas estratégicas antes de decidir.',
    'scenario.revenueChange': 'Variación de ingresos',
    'scenario.costChange': 'Variación de costes',
    'scenario.hires': 'Nuevas contrataciones',
    'scenario.investment': 'Inversión puntual',
    'scenario.result': 'Resultado del escenario',
    'scenario.projectedProfit': 'Beneficio proyectado',
    'scenario.projectedCash': 'Tesorería a fin de año',
    'scenario.reset': 'Reiniciar',
    'scenario.question': '¿Puedo permitírmelo?',

    // Forecast
    'forecast.title': 'Previsión',
    'forecast.subtitle': 'Compara lo real con la previsión y el objetivo.',
    'forecast.actual': 'Real',
    'forecast.forecast': 'Previsión',
    'forecast.target': 'Objetivo',

    // Alerts
    'alerts.title': 'Centro de alertas',
    'alerts.subtitle': 'Detectamos antes de que ocurra.',
    'alerts.critical': 'Crítica',
    'alerts.important': 'Importante',
    'alerts.attention': 'Atención',
    'alerts.information': 'Información',
    'alerts.opportunity': 'Oportunidad',
    'alerts.all': 'Todas',

    // Calendar
    'calendar.title': 'Obligaciones y calendario',
    'calendar.subtitle': 'Vencimientos, solicitudes y cierres.',
    'calendar.upcoming': 'Próximas obligaciones',
    'calendar.type.tax': 'Obligación fiscal',
    'calendar.type.payment': 'Pago',
    'calendar.type.doc': 'Solicitud documentación',
    'calendar.type.close': 'Cierre mensual',

    // Tasks
    'tasks.title': 'Pendientes',
    'tasks.subtitle': 'Tu bandeja de trabajo.',
    'tasks.todo': 'Por hacer',
    'tasks.inProgress': 'En progreso',
    'tasks.completed': 'Completado',
    'tasks.markDone': 'Marcar como hecho',

    // Documents
    'docs.title': 'Centro documental',
    'docs.subtitle': 'Sube, gestiona y responde a solicitudes.',
    'docs.requested': 'Documentos solicitados',
    'docs.recent': 'Documentos recientes',
    'docs.status.pending': 'Pendiente',
    'docs.status.uploaded': 'Subido',
    'docs.status.review': 'En revisión',
    'docs.status.approved': 'Aprobado',
    'docs.dropzone': 'Arrastra archivos aquí o haz clic para subir',

    // Advisor
    'advisor.title': 'AI Advisor',
    'advisor.subtitle': 'Pregunta sobre el estado de tu empresa.',
    'advisor.placeholder': 'Escribe tu pregunta...',
    'advisor.greeting': 'Hola Xavi, soy tu asesor inteligente. ¿En qué puedo ayudarte hoy?',
    'advisor.suggestions': 'Preguntas sugeridas',
    'advisor.thinking': 'Analizando tus datos...',
    'advisor.open': 'Abrir Advisor',

    // Recommendations
    'rec.title': 'Recomendaciones',
    'rec.subtitle': 'Acciones sugeridas basadas en tus datos.',
    'rec.detected': 'Detectada',
    'rec.analyzed': 'Analizada',
    'rec.presented': 'Presentada',
    'rec.accepted': 'Aceptada',
    'rec.dismissed': 'Descartada',
    'rec.impact': 'Impacto estimado',

    // Team
    'team.title': 'Mi equipo asesor',
    'team.subtitle': 'Detrás de la plataforma hay un equipo real.',
    'team.contact': 'Contactar',
    'team.book': 'Agendar reunión',

    // Notifications
    'notif.title': 'Notificaciones',
    'notif.subtitle': 'Todo lo que ha pasado recientemente.',
    'notif.markAll': 'Marcar todo como leído',
    'notif.empty': 'No tienes notificaciones nuevas.',

    // Right panel
    'panel.myTasks': 'Mis tareas',
    'panel.quickActions': 'Acciones rápidas',
    'panel.advisorTeam': 'Tu asesor',
    'panel.nextObligation': 'Próxima obligación',
    'panel.upcoming': 'Próximamente',
    'panel.attention': 'Requiere atención',
    'panel.activity': 'Actividad reciente',
    'panel.insights': 'Insights',
    'panel.days': 'días',
    'panel.today': 'hoy',
    'panel.askAdvisor': 'Preguntar al Advisor',
  },
  en: {
    'nav.today': 'Today',
    'nav.company': 'My company',
    'nav.finance': 'Finance',
    'nav.profitability': 'Profitability',
    'nav.cash': 'Cash',
    'nav.plan': 'Plan',
    'nav.forecast': 'Forecast',
    'nav.alerts': 'Alerts',
    'nav.tasks': 'Tasks',
    'nav.advisor': 'Advisor',
    'nav.documents': 'Documents',
    'nav.calendar': 'Calendar',
    'nav.recommendations': 'Recommendations',
    'nav.team': 'My advisory team',
    'nav.notifications': 'Notifications',
    'nav.group.overview': 'Overview',
    'nav.group.intelligence': 'Intelligence',
    'nav.group.action': 'Action',
    'nav.more': 'More',

    'common.viewAll': 'View all',
    'common.viewDetail': 'View detail',
    'common.vsPrev': 'vs previous period',
    'common.vsTarget': 'vs target',
    'common.noData': 'NO DATA',
    'common.noDataDesc': 'There is not enough connected data yet to show this information.',
    'common.connect': 'Connect data',
    'common.search': 'Search...',
    'common.close': 'Close',
    'common.send': 'Send',
    'common.logout': 'Log out',
    'common.settings': 'Settings',
    'common.of': 'of',
    'common.showMore': 'Show more',
    'common.why': 'Why?',
    'common.whatToDo': 'What to do?',
    'common.status': 'Status',
    'common.amount': 'Amount',
    'common.date': 'Date',
    'common.pending': 'Pending',
    'common.done': 'Done',
    'common.accept': 'Accept',
    'common.dismiss': 'Dismiss',
    'common.upload': 'Upload',

    'login.tagline': "Your company's intelligent financial hub",
    'login.subtitle': 'Understand how your company is doing and know what to do next.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.signin': 'Sign in',
    'login.demo': 'Continue with demo account',
    'login.selectCompany': 'Select your company',
    'login.selectCompanyDesc': 'You have access to several organizations. Pick one to continue.',
    'login.enter': 'Enter',
    'login.feature1': 'Visibility · What is happening?',
    'login.feature2': 'Analysis · Why is it happening?',
    'login.feature3': 'Prediction · What will happen?',
    'login.feature4': 'Advisory · What should I do?',

    'today.greeting': 'Good morning',
    'today.intro': "Here is what matters most for your company.",
    'today.healthStatus': 'Overall status',
    'today.requiresAttention': 'Requires attention',
    'today.requiresAttentionDesc': 'What needs your decision today',
    'today.aiInsight': 'Advisor insight',
    'today.pending': 'Your tasks',
    'today.upcoming': 'Upcoming deadlines',

    'health.title': 'Company health',
    'health.subtitle': 'A global view without having to read financial statements.',
    'health.score': 'Health score',
    'health.liquidity': 'Liquidity',
    'health.profitability': 'Profitability',
    'health.growth': 'Growth',
    'health.debt': 'Debt',
    'health.stability': 'Stability',
    'health.risk': 'Risk',
    'health.trend': 'Health evolution',

    'finance.title': 'Financial overview',
    'finance.subtitle': 'How much comes in, how much goes out and what remains.',
    'finance.revenue': 'Revenue',
    'finance.expenses': 'Expenses',
    'finance.profit': 'Profit',
    'finance.margin': 'Margin',
    'finance.evolution': 'Revenue vs expenses evolution',
    'finance.breakdown': 'Expense breakdown',

    'prof.title': 'Profitability',
    'prof.subtitle': 'Which parts of your business really generate profit?',
    'prof.clients': 'Clients',
    'prof.products': 'Products',
    'prof.services': 'Services',
    'prof.projects': 'Projects',
    'prof.departments': 'Departments',
    'prof.name': 'Name',
    'prof.marginPct': 'Margin',
    'prof.contribution': 'Contribution',

    'cash.title': 'Cash intelligence',
    'cash.subtitle': 'How much cash you really have and what happens next.',
    'cash.available': 'Available today',
    'cash.inflows': 'Expected inflows',
    'cash.outflows': 'Expected outflows',
    'cash.projected': 'Projected balance',
    'cash.timeline': 'Cash projection (90 days)',
    'cash.movements': 'Upcoming movements',
    'cash.runway': 'Cash runway',
    'cash.months': 'months',

    'scenario.title': 'Scenario planner',
    'scenario.subtitle': 'Answer strategic questions before you decide.',
    'scenario.revenueChange': 'Revenue change',
    'scenario.costChange': 'Cost change',
    'scenario.hires': 'New hires',
    'scenario.investment': 'One-off investment',
    'scenario.result': 'Scenario result',
    'scenario.projectedProfit': 'Projected profit',
    'scenario.projectedCash': 'Year-end cash',
    'scenario.reset': 'Reset',
    'scenario.question': 'Can I afford it?',

    'forecast.title': 'Forecast',
    'forecast.subtitle': 'Compare actuals with forecast and target.',
    'forecast.actual': 'Actual',
    'forecast.forecast': 'Forecast',
    'forecast.target': 'Target',

    'alerts.title': 'Alerts center',
    'alerts.subtitle': 'We detect before it happens.',
    'alerts.critical': 'Critical',
    'alerts.important': 'Important',
    'alerts.attention': 'Attention',
    'alerts.information': 'Information',
    'alerts.opportunity': 'Opportunity',
    'alerts.all': 'All',

    'calendar.title': 'Obligations & calendar',
    'calendar.subtitle': 'Deadlines, requests and closings.',
    'calendar.upcoming': 'Upcoming obligations',
    'calendar.type.tax': 'Tax obligation',
    'calendar.type.payment': 'Payment',
    'calendar.type.doc': 'Document request',
    'calendar.type.close': 'Monthly close',

    'tasks.title': 'Tasks',
    'tasks.subtitle': 'Your work inbox.',
    'tasks.todo': 'To do',
    'tasks.inProgress': 'In progress',
    'tasks.completed': 'Completed',
    'tasks.markDone': 'Mark as done',

    'docs.title': 'Document center',
    'docs.subtitle': 'Upload, manage and respond to requests.',
    'docs.requested': 'Requested documents',
    'docs.recent': 'Recent documents',
    'docs.status.pending': 'Pending',
    'docs.status.uploaded': 'Uploaded',
    'docs.status.review': 'In review',
    'docs.status.approved': 'Approved',
    'docs.dropzone': 'Drag files here or click to upload',

    'advisor.title': 'AI Advisor',
    'advisor.subtitle': 'Ask about the state of your company.',
    'advisor.placeholder': 'Type your question...',
    'advisor.greeting': "Hi Xavi, I'm your intelligent advisor. How can I help you today?",
    'advisor.suggestions': 'Suggested questions',
    'advisor.thinking': 'Analyzing your data...',
    'advisor.open': 'Open Advisor',

    'rec.title': 'Recommendations',
    'rec.subtitle': 'Suggested actions based on your data.',
    'rec.detected': 'Detected',
    'rec.analyzed': 'Analyzed',
    'rec.presented': 'Presented',
    'rec.accepted': 'Accepted',
    'rec.dismissed': 'Dismissed',
    'rec.impact': 'Estimated impact',

    'team.title': 'My advisory team',
    'team.subtitle': 'There is a real team behind the platform.',
    'team.contact': 'Contact',
    'team.book': 'Book a meeting',

    'notif.title': 'Notifications',
    'notif.subtitle': 'Everything that happened recently.',
    'notif.markAll': 'Mark all as read',
    'notif.empty': 'You have no new notifications.',

    'panel.myTasks': 'My tasks',
    'panel.quickActions': 'Quick actions',
    'panel.advisorTeam': 'Your advisor',
    'panel.nextObligation': 'Next obligation',
    'panel.upcoming': 'Upcoming',
    'panel.attention': 'Requires attention',
    'panel.activity': 'Recent activity',
    'panel.insights': 'Insights',
    'panel.days': 'days',
    'panel.today': 'today',
    'panel.askAdvisor': 'Ask the Advisor',
  },
};
